import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"

import { cn } from "@/lib/utils"
import { Icon } from "@/icons/icon"

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        `
          peer border-input bg-white data-[state=checked]:bg-white data-[state=checked]:text-blue 
          data-[state=checked]:border-blue focus-visible:border-ring focus-visible:ring-ring/50 
          aria-invalid:ring-destructive/20 aria-invalid:border-destructive 
          size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none 
          focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50
        `,
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        <Icon name="Check" className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
